import Controller from 'controllers/controller';

class HomeTemplateController extends Controller {
    condition() {
        return this.app.pageTemplateIs('home');
    }
    
    ready() {
        
    }
    
    cacheElements() {
        
    }
}

export default HomeTemplateController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/templates/home.js